import axios from "axios";
import {
  getApiErrorMessage,
  isAuthError,
  parseApiResponse,
} from "../../../utils/apiResponse";
import { TRANSIENT_HTTP_STATUSES } from "../../../constants/httpStatus";
import { authorizationHeaders, redirectToLogin } from "../../../utils/authSession";
import { mapCustomerPath } from "../../../utils/pathMap";

type ApiParams = {
  data?: any;
  method: string;
  headers?: Record<string, string>;
};

const api = axios.create({
  baseURL: process.env.REACT_APP_SERVER_URI,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
  timeout: 90000,
});

export async function callApi(path: string, params: ApiParams) {
  const response = await api({
    url: mapCustomerPath(path),
    ...params,
    headers: {
      ...authorizationHeaders(),
      ...(params?.headers || {}),
    },
    validateStatus: () => true,
  });

  const res = response.data as any;
  const errMessage = getApiErrorMessage(res);

  if (res.err || res.success === false) {
    if (isAuthError(response.status, errMessage)) {
      redirectToLogin();
    }

    const errStatus = res.err?.status;
    if (TRANSIENT_HTTP_STATUSES.includes(errStatus as typeof TRANSIENT_HTTP_STATUSES[number])) {
      return res.err;
    }

    const error = new Error(errMessage) as Error & {
      status?: number;
      response?: unknown;
    };
    error.status = response.status;
    error.response = response;
    throw error;
  }

  return parseApiResponse(response);
}
